import { setSessionItem, getSessionItem } from "./chatUtility";

// generate genesys ID.
function get_genesysID() {
  var genesysID;

  if (getSessionItem("genesysID")) {
    genesysID = getSessionItem("genesysID");
  } else {
    // generate unique genesys session token
    var prefix = "0000000-0000-0000-0000-";
    // randomizing last 10 digits
    var postfix = String(Math.floor(1000000000 + Math.random() * 9000000000));
    genesysID = prefix.concat(postfix);
    //console.log(genesysID);
    setSessionItem("genesysID", genesysID);
  }

  return genesysID;
}

function createGenesysWebSocket() {
  const serverAddress = process.env.REACT_APP_GENESYS_SERVER_ADDRESS;
  if (!serverAddress) {
    throw new Error("Server address is undefined");
  }
  const wsClient = new WebSocket(serverAddress);

  wsClient.onopen = (event) => {
    wsClient.send(
      JSON.stringify({
        action: "configureSession",
        deploymentId: process.env.REACT_APP_GENESYS_DEPLOYMENT_ID,
        token: get_genesysID(),
      })
    );
  };
  return wsClient;
}

export { get_genesysID, createGenesysWebSocket };
